// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pyJK","rootMobile":"styles_rootMobile__3yegA"};